import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import Spacer from 'client/shared/blocks/spacer'
import { Heading } from 'client/shared/blocks/heading'
import { BestsellersHeader } from 'client/bookmate/blocks/bestsellers-header'
import TaxesComment from 'client/bookmate/blocks/subscription-form/taxes-comment'

type Props = {
  userCountry: string
  isMobileSize: boolean
}

export class GiftsHead extends Component<Props> {
  render(): JSX.Element {
    const { isMobileSize, userCountry } = this.props

    return (
      <>
        <Spacer size="top-page" />
        <BestsellersHeader userCountry={userCountry} />
        {!isMobileSize && <Spacer size={32} />}
        <Heading kind="kazimir" rank={isMobileSize ? 2 : 1} extraLarge centered>
          <Trans id="gifts.index_title" />
        </Heading>
        <Spacer size={24} />
        <div className="gifts_description">
          <Trans id="gifts.index_description" />
        </div>
        <TaxesComment />
        <Spacer size={isMobileSize ? 32 : 56} />
      </>
    )
  }
}
